import {
  ChartBarSquareIcon,
  ShieldCheckIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";
import type { ComponentType, SVGProps } from "react";
import type { StatisticsTab } from "../types";

const tabs: {
  id: StatisticsTab;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}[] = [
  { id: "numbers", label: "المجاميع", icon: ChartBarSquareIcon },
  { id: "assignment", label: "إحصائيات الإسناد", icon: UserGroupIcon },
  { id: "quality", label: "إحصائيات الجودة", icon: ShieldCheckIcon },
];

const Tabs = ({
  activeTab,
  handleTabChange,
}: {
  activeTab: StatisticsTab;
  handleTabChange: (tab: StatisticsTab) => void;
}) => {
  return (
    <nav className="relative">
      <div
        role="tablist"
        className="relative -mx-1 mb-5 flex flex-nowrap items-center gap-1 overflow-x-auto whitespace-nowrap rounded-2xl border border-gray-100 bg-gradient-to-l from-purple-50/30 via-white to-purple-50/20 p-1.5 backdrop-blur-sm [-ms-overflow-style:none] [scrollbar-width:none] dark:border-gray-700/60 dark:from-purple-950/15 dark:via-gray-800 dark:to-purple-950/10 [&::-webkit-scrollbar]:hidden"
      >
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => handleTabChange(tab.id)}
              className={`group/tab relative inline-flex shrink-0 items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-medium tracking-tight transition-all duration-200 ${
                isActive
                  ? "bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-md shadow-purple-900/25 ring-1 ring-purple-900/10 dark:from-purple-600 dark:to-purple-800"
                  : "text-gray-600 hover:bg-white hover:text-purple-900 hover:shadow-sm dark:text-gray-400 dark:hover:bg-gray-700/60 dark:hover:text-purple-300"
              }`}
            >
              <Icon
                className={`h-4 w-4 transition-transform ${
                  isActive ? "" : "group-hover/tab:scale-110"
                }`}
              />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default Tabs;
